<template>
  <div id="user-manage">
    <!--搜索-->
    <div class="top">
      <el-col :span="12">
        <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :span="2" :offset="1">
      <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
       </el-col>
      <el-upload
        class="upload-btn"
        :action="uploadUrl"
        :show-file-list="false"
        :http-request="httpRequest" >

        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <!--表格-->
    <div class="user-table scrollable-container">
      <el-table border :data="tableData">
        <el-table-column label="产业链ID" align="center" min-width="15%"  prop="id">
          <template slot-scope="scope">
            <span  @click="handleCellClick_word(scope.row)" :style="{ color: scope.row.word === 1 ? 'blue' : 'red' }">{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产业链名称" align="center" min-width="20%" prop="name">
          <template slot-scope="scope">
            <span  @click="handleCellClick(scope.row)" :style="{ color: 'blue' }">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否置顶" align="center"  min-width="20%" prop="rank"></el-table-column>
        <el-table-column label="创建时间" align="center"  min-width="20%" prop="created"></el-table-column>
        <el-table-column label="创建人" align="center"  min-width="20%"  prop="author"></el-table-column>
        <el-table-column label="是否展示" align="center"  min-width="20%"  prop="status"></el-table-column>
        <el-table-column label="操作"    align="center" min-width="20%" width="110">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">禁用/启用</el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除"    align="center" min-width="20%" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">点击删除</el-button>
          </template>
        </el-table-column>
         <el-button type="primary" size="small" >下载模板</el-button>
        <el-table-column label="下载原始文件" align="center" min-width="20%" prop="name">
          <template slot-scope="scope">
            <span class="link-text" @click="handleDownClick(scope.row)">{{ "点击下载" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="置顶"    align="center" min-width="20%" width="110">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleRank( scope.row)">置顶/取消</el-button>
          </template>
        </el-table-column>


      </el-table>
    </div>
    <!--修改模版信息-->
    <div>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormBZVisible"
        :modal-append-to-body="false"
        v-if="dialogFormBZVisible"
        :showClose="false"
      >
        <el-form :model="updateInfo" ref="userInfoForm" label-width="100px">
          <el-form-item label="备注信息" prop="avatar">
            <el-input v-model="updateInfo.avatar" placeholder="请输入备注信息"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取消</el-button>
          <el-button type="primary" @click="submit()">提交</el-button>
        </div>
      </el-dialog>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserInfo, updateUserInfo,deleteUserInfo,overUserInfo,DownloadXlsl,updateCylRank} from "../../../api/index";
import { MessageBox, Message,DatePicker } from "element-ui";
import axios from "axios";
import Router from 'vue-router'

export default {
  name: "UserManage",
  data() {
    return {
      //服务器地址
      tableData: [],
      total: 0,
      currentPage: 1,
      userInfo: {},
      expirationDate:"",
      dialogFormVisible: false,
      dialogFormBZVisible: false,
      dialogTitle: "",
      searchInput: "",
      input: "",
      cyl_id: "",
      downloadLink: "https://www.windustry.top/upload.xlsx",
      uploadUrl:"https://www.windustry.top/admin/xlsx/upload",
      updateInfo: {},
      labelPosition: "right",
      fid : ""
    };
  },
  created() {
    this.getUserInfo(this.currentPage, 8, "");
    this.uploadUrl = 'https://www.windustry.top/admin/xlsx/upload'

  },
  methods: {
    downloadTemplate() {
    const link = document.createElement('a');
    link.href = this.downloadLink;
    link.download = 'https://www.windustry.top/demo.xlsx';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

    async getUserInfo(currentPage, pageSize, searchInput) {
      let json = await getUserInfo(currentPage, pageSize, searchInput);
      if (json.code === 200) {
        this.tableData = json.data;
        this.total = Math.ceil(json.total / 10);
      }
    },
    async handleEdit(index, row) {
      MessageBox.confirm("此操作可能更改该产业链状态, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateUserInfo(row.id, row.status);
          if (json.code === 200) {
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("更新成功");
          }
        }
      });
    },
    async handleDelete(index, row) {
      MessageBox.confirm("此操作可能删除该产业链状态, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await deleteUserInfo(row.id);
          if (json.code === 200) {
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("删除成功");
          }
        }
      });
    },

    async handleCellClick(row) {
      this.fid = row.id;
      this.$router.push('/home/banner_manage?id='+this.fid);
    },

    async handleCellClick_word(row)
      {
      this.fid = row.id;
      this.$router.push('/home/banner_manage?id='+this.fid);
    },

    async handleDownClick(row) {
      let json = await DownloadXlsl(row.id);
          if (json.code === 200) {
            let downloadUrl = json.url;
            window.open(downloadUrl, "_blank");
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("下载成功");
      }
    },

    async updateExpiration(row){
      MessageBox.confirm("此操作可能更改该用户过期时间, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateUserInfo(row.id, row.expiration);
          if (json.code === "200") {
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("更改成功");
          }
        }
      });
    },


    async ChangePass(row) {
      MessageBox.confirm("此操作可能重置用户密码, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateUserInfo(row.id, '密码');
          if (json.code === "200") {
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("更改成功");
          }
        }
      });
    },

    async handleRank(row){
     if (row.rank==='置顶'){
        MessageBox.confirm("此操作会取消置顶该产业链信息, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateCylRank(row.id,'-1');
          if (json.code === "200") {
            Message.success(json.msg);
          } else {
             Message.success(json.msg);
          }
          this.getUserInfo(this.currentPage, 8, "");
        }
      })
      } else {
      MessageBox.confirm("此操作会置顶该产业链信息, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateCylRank(row.id,'1');
          if (json.code === "200") {

            Message.success(json.msg);
          } else {
             Message.success(json.msg);
          }
          this.getUserInfo(this.currentPage, 8, "");

        }
      })}

    },

    async handleBZEdit(row) {
      MessageBox.confirm("此操作可能更改该用户备注信息, 是否继续？", "提示").then(async (value) => {
        if (value === "confirm") {
          let json = await updateUserInfo(row.id, row.avatar);
          if (json.code === "200") {
            this.getUserInfo(this.currentPage, 8, "");
            Message.success("更改成功");
          }
        }
      });
    },

    EditAvatar(row) {
      this.dialogFormBZVisible = true;
      this.dialogTitle = "编辑备注";
      this.updateInfo = { ...row };
    },

    async submit() {
      let json = await updateUserInfo(this.updateInfo.id, this.updateInfo.avatar);
      if (json.code === "200") {
        this.getUserInfo(this.currentPage, 8, "");
        Message.success("更改成功");
        this.dialogFormBZVisible = false;
      }
    },

    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getUserInfo(this.currentPage, 8, "");
    },

    httpRequest(op) {
              const formData = new FormData();
              formData.append('file', op.file);
              formData.append('type', 'upload');
              axios.post(this.uploadUrl,formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                let json  = response.data; // 从响应中获取数据;

                if (json.code===200 || json.code===201){

                    Message.success(json.msg);
                    console.log(json.code)
                    if (json.code === 200){
                      this.getUserInfo(this.currentPage, 8, "");
                    } else {
                      this.cyl_id = json.cyl_id
                      MessageBox.confirm("数据库存在相同产业链,是否覆盖替换?", "提示").then(async (value) => {
                        if (value === "confirm") {
                          let json =await overUserInfo(this.cyl_id);
                          if (json.code === 200){
                            Message.success(json.msg);
                            this.getUserInfo(this.currentPage, 8, "");
                          }
                        }});
                    }

                  }
              })
              .catch(error => {
                // 处理上传失败的逻辑
                 Message.error('上传失败，请重试')
              });

            },


    formatBoolean: function (row, column, cellValue) {
      var ret = ""; //你想在页面展示的值
      if (cellValue) {
        ret = "是"; //根据自己的需求设定
      } else {
        ret = "否";
      }
      return ret;
    },
    //搜索用户
    search() {
      this.searchInput = this.input;
      this.getUserInfo(1, 8, this.searchInput);
    },
    cancel() {
      this.getUserInfo(1, 8, "");
      this.dialogFormVisible = false;
      this.dialogFormBZVisible = false;
    },
  },
};
</script>

<style scoped>
.user-table {
  width: 90%;
  min-width: 1300px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.scrollable-container {
  height: 600px; /* 设置容器的高度 */
  overflow-y: scroll; /* 垂直滚动条 */
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 30px 0; */
  margin-bottom: 30px;
}
.block {
  text-align: center;
}
.el-dialog__header {
  text-align: center;
}
.el-dialog__body .el-form-item {
  padding-left: 20%;
}
 .opera-img {
  color: #00BFFF; /* 设置蔚蓝色，可以根据需要调整颜色值 */
}
.link-text {
  color: #00BFFF; /* 设置蔚蓝色，可以根据需要调整颜色值 */
  cursor: pointer; /* 添加鼠标指针样式，使其可点击 */
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/UserManage.vue